import { memo } from 'react';
import { classNames } from '~/utils/classNames';

interface UserAvatarProps {
  backgroundColor?: string;
  textColor?: string;
  className?: string;
  avatar?: string;
  iconClassName?: string;
}

export const UserAvatar = memo(
  ({
    className,
    backgroundColor = 'bg-background',
    textColor = 'text-bolt-elements-textSecondary',
    avatar,
    iconClassName,
  }: UserAvatarProps) => {
    return (
      <div
        className={classNames(
          'flex select-none items-center justify-center size-8 overflow-hidden rounded-full shrink-0',
          backgroundColor,
          textColor,
          className,
        )}
      >
        {avatar ? (
          <img className="w-full h-full object-cover" src={avatar} />
        ) : (
          <div className={classNames('text-xl', iconClassName ?? 'i-ph:user-fill')}></div>
        )}
      </div>
    );
  },
);
